<div id="accordionPosBrands">
  <dq-accordion id="posBrands" icon="icon-marcas.svg" label="Marcas">
    <div class="card-body px-0">
      <ul class="list-group list-group-flush">
        <li class="list-group-item">
          <div class="row">
            <div class="col-md-6 text-center" *ngIf="isVisibleBrand('Advance')">
              <img src="assets/img/logo-advance.png" alt="Advance" />
            </div>
            <div
              class="col-md-6 text-center"
              *ngIf="isVisibleBrand('Nature\'s Variety')"
            >
              <img src="assets/img/logo-nature.png" alt="Nature's Variety" />
            </div>
            <div
              class="col-md-6 text-center"
              *ngIf="isVisibleBrand('Libra Balance')"
            >
              <img
                src="assets/img/logo-libra-balance.png"
                alt="Libra Balance"
              />
            </div>
            <div class="col-md-6 text-center" *ngIf="isVisibleBrand('Trainer')">
              <img src="assets/img/logo-trainer.png" alt="Trainer" />
            </div>
            <div
              class="col-md-6 text-center"
              *ngIf="isVisibleBrand('Advance Diets')"
            >
              <img
                src="assets/img/logo-advance-diets.png"
                alt="Advance diets"
              />
            </div>
            <!--
            <div
              class="col-md-6 text-center"
              *ngIf="isVisibleBrand('Brekkies Excel')"
            >
              <img src="assets/img/logo-brekkies.png" alt="Brekkies Excel" />
            </div>
          -->
            <!--
            <div class="col-md-6 text-center" *ngIf="isVisibleBrand('Ultima')">
              <img src="assets/img/logo-ultima.png" alt="Ultima" />
            </div>
          --></div>
        </li>
      </ul>
    </div>
  </dq-accordion>
</div>
